export default __webpack_public_path__ + "logo-dark.cdff8d9ede4af80de77f16522bd537fc.svg";